import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, ref, Ref } from "vue"
import type { ComponentPublicInstance } from "vue"

// Utils
import { isScreenMD } from "@/vue/planning/utils/breakpoints"

// Components
import FixedPaymentConditionPill from "./FixedPaymentConditionPill.vue"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"
import PackageDetailsTooltip from "./PackageDetailsTooltip.vue"
import DynamicPopup from "@/vue/common/DynamicPopup.vue"
import PaymentConditionPopup from "./PaymentConditionPopup.vue"

// Common computeds
import conditionsUrl from "../../../computed/conditionsUrl"

// Props
interface Props {
	displayTitle: boolean
	content: { [key: string]: string }
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	cancellationDate?: string
}

type DynamicPopupInstance = ComponentPublicInstance<typeof DynamicPopup>


export default /*#__PURE__*/_defineComponent({
  __name: 'FixedPaymentCondition',
  props: {
    displayTitle: { type: Boolean },
    content: null,
    isPVFlex: { type: Boolean },
    prestId: null,
    isDisplayPlaceholders: { type: Boolean },
    cancellationDate: null
  },
  setup(__props: any) {

const props = __props as {
	displayTitle: boolean
	content: { [key: string]: string }
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	cancellationDate?: string
};



// Refs
const popupRef: Ref<DynamicPopupInstance | null> = ref(null)

// Computed
const content: ComputedRef<{ [key: string]: string }> = computed(() => {
	return props.content
})

// Methods
const handleOpenPopup = (): void => {
	// Only open the popup if the device is mobile
	if (isScreenMD.value) return

	if (popupRef.value) {
		popupRef.value.openPopup()
	}
}

const handleClosePopUp = () => {
	if (popupRef.value) {
		popupRef.value.closePopup()
	}
}

return { __sfc: true,props, popupRef, content, handleOpenPopup, handleClosePopUp, FixedPaymentConditionPill, PlaceholderBox, PackageDetailsTooltip, DynamicPopup, PaymentConditionPopup, conditionsUrl }
}

})